<div
  class="card card-select"
  [ngClass]="{ 'card-selected': product.selected, 'card-hover': this.enableSelection }"
  (click)="onSelectCard(allProducts, product)"
  >
  @if (product.selected) {
    <span class="selection">
      <mat-icon>check_circle</mat-icon>
    </span>
  }
  <udx-cx-attraction-event
    [product]="product"
    [shouldGroupProducts]="shouldGroupProducts"
  [key]="key" ></udx-cx-attraction-event>
</div>